<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-6" [ngClass]="{ 'w-100': owners?.length > 1 }">
          <pr-input-column
            label="Épargne mensuelle"
            [derrors]="derrors"
            [isDefault]="false"
            [suffix]="'€/mois'"
          >
            <input
              notdot
              matInput
              placeholder="Exemple : 200 €"
              formControlName="monthlySaving"
              type="text"
            />
          </pr-input-column>
        </div>
        <div class="col-md-6" [ngClass]="{ 'w-100': owners?.length > 1 }">
          <pr-input-column
            label="Épargne de précaution"
            [derrors]="derrors"
            [isDefault]="false"
            [suffix]="'€'"
          >
            <input
              notdot
              matInput
              placeholder="Exemple : 200 €"
              formControlName="epargnePrecaution"
              type="text"
            />
          </pr-input-column>
        </div>
        <div class="col-md-6" [ngClass]="{ 'w-100': owners?.length > 1 }">
          <pr-input-column
            label="Montant à investir"
            [derrors]="derrors"
            [isDefault]="false"
            [suffix]="'€'"
          >
            <input
              notdot
              matInput
              placeholder="Exemple : 3000 €"
              formControlName="liquidity"
              type="text"
            />
          </pr-input-column>
        </div>
      </div>
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
@if (isSubmitting) {
  <pr-loader></pr-loader>
}
